<template>
  <div class="right-pane greenapi-iframe-wrapper"
       :class="[{ opened }, `platform-${platform}`]"
       v-if="panelEnabled">
    <div class="container" style="height: 50px; background: #181a1b">
      <div class="text-right">
        <a @click="toggleJetAPIChat"
           class="d-inline-flex pointer py-3">
          <CloseSvg class="svg-light svg-size-md"/>
        </a>
      </div>
    </div>
    <iframe :src="iframeUrl"
            v-if="initiated && iframeUrl"
            class="greenapi-iframe"></iframe>
  </div>
</template>

<script setup>
import CloseSvg from '@/assets/svg-vue/general/close.svg'
import {computed, ref, watch} from "vue"
import { useStore } from "vuex"
import {CRMService} from "@/services/api/crm.api.service"

const store = useStore()

const opened = computed(() => store.state.dom.rightPaneOpened)
const platform = computed(() => store.state.dom.messengerPanelPlatform)
const getters = store.getters
const greenAPIWhatsappPanelEnabled = computed(() => getters.greenAPIPanelEnabled)
const greenAPIMaxPanelEnabled = computed(() => getters.greenAPIMaxPanelEnabled)
const greenAPITelegramPanelEnabled = computed(() => getters.greenAPITelegramPanelEnabled)
const phone = computed(() => store.state.dom.phoneForJetApi?.phone || null)
const panelEnabled = computed(() => {
  if(platform.value === "whatsapp") return greenAPIWhatsappPanelEnabled.value
  if(platform.value === "telegram") return greenAPITelegramPanelEnabled.value
  if(platform.value === "max") return greenAPIMaxPanelEnabled.value
  return false
})
const chatId = ref('')
const iframeUrl = ref('')
const initiated = ref(false)

const toggleJetAPIChat = () => {
  store.state.dom.rightPaneOpened = !store.state.dom.rightPaneOpened
}

watch(opened, async (val) => {
  if(val) {
    if(platform.value !== "whatsapp") {
      const res = await CRMService.getMessengerChatId(phone.value || '', platform.value)
      chatId.value = res.data || ''
    }
    iframeUrl.value = getters.greenAPIIframeUrl(chatId.value || phone.value, platform.value)
    initiated.value = true
  }
  if (!val) {
    store.state.dom.phoneForJetApi = null
    chatId.value = ''
    iframeUrl.value = ''
    initiated.value = false
  }
})
</script>

<style>
.right-pane {
  position: fixed;
  right: 0;
  width: 0;
  height: 100vh;
  top: 0;
  background: #fff;
  z-index: 10;
  border-left: 1px solid #dee2e6;
  transition: width 0.2s;
  &.opened {
    width: 460px;
  }
}
.greenapi-iframe {
  width: 100%;
  border: none;
  height: calc(100vh - 50px);
}
@media screen and (max-width: 768px) {
  .right-pane {
    &.opened {
      width: 100%;
    }
  }
}
</style>
